import * as mutationTypes from '@/store/mutation-types'
import { userCollectList } from '@/api/collection'
const market = {
  namespaced: true,
  state: {
    collectCoinListLocal: [], // 用户本地收藏的币种列表（用来进行对比）
    collectCoinListOrigin: [] // 用户远程收藏的币种列表（用来进行对比）
  },
  mutations: {
    [mutationTypes.ADD_LOCAL_COLLECTION](state, coin) {
      state.collectCoinListLocal.push(coin)
    },
    [mutationTypes.DELETE_LOCAL_COLLECTION](state, idx) {
      state.collectCoinListLocal.splice(idx, 1)
    },
    [mutationTypes.SET_COLLECTION_COIN](state, collectCoinListOrigin) {
      state.collectCoinListOrigin = collectCoinListOrigin
    }
  },
  actions: {
    async setCollectionCoin({ commit }) {
      const data = await userCollectList()
      commit(mutationTypes.SET_COLLECTION_COIN, data)
    }
  }
}

export default market
